/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectcover2Inputs */

const en_cropaspectcover2 = /** @type {(inputs: Cropaspectcover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

const de_cropaspectcover2 = /** @type {(inputs: Cropaspectcover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

/**
* | output |
* | --- |
* | "Cover" |
*
* @param {Cropaspectcover2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectcover2 = /** @type {((inputs?: Cropaspectcover2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectcover2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectcover2(inputs)
	return de_cropaspectcover2(inputs)
});
export { cropaspectcover2 as "cropAspectCover" }